export const customDateFormatter = (dateString: string, formatString: string): string => {
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      // Check if the date is invalid
      return dateString; // Return the input string for invalid dates
    }
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();

    return formatString.replace('PP', `${month} ${day}, ${year}`);
  } catch (e) {
    return dateString;
  }
};

/**
 * Convert input to a Date object
 * @param date - The date to convert, can be string, number (timestamp), or Date object
 * @returns Date object
 */
export const toDate = (date: string | number | Date): Date => {
  return new Date(date);
};

/**
 * Check if a target date is overdue (before today)
 * Normalizes both dates to midnight for day-level comparison
 * @param targetDate - The date to check, can be string, number (timestamp), or Date object
 * @returns true if the target date is before today, false otherwise (including if date is invalid/null/undefined)
 */
export const isTodayOverdue = (targetDate: string | number | Date | null | undefined): boolean => {
  if (!targetDate) return false;

  try {
    const target = new Date(targetDate);
    const today = new Date();

    // Check if date is invalid
    if (isNaN(target.getTime())) {
      return false;
    }

    // Normalize both dates to midnight for day-level comparison
    target.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return target < today;
  } catch (e) {
    return false;
  }
};
